<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onRefresh)="onReset()"
  (onSelectAll)="onSelectAllMobileNumber($event)"
  [id]="'receivers-' + scheduledMessageId"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!---------------------------------------- Header Btns --------------------------------------->

  <div class="card-toolbar" custom-elements>
    <!-- delivery Status Chart btn -->
    <a
      class="btn btn-light txt-lg button-shadow tw-mx-1 text-purple btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.deliveryStatusStats' | translate"
      (click)="deliveryStatusChart()"
    >
      <i class="mdi mdi-chart-arc mdi-20px tw-p-0 text-purple"></i>
    </a>

    <!-- onEditDeliveryStatus -->
    <div [matTooltip]="'common.selectiveEditDeliveryStatus' | translate">
      <button
        (click)="onEditDeliveryStatus('selective')"
        [disabled]="mobileNumbers?.length == 0"
        *ngIf="userSession.organizationId() == 1"
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-navyBlue btn-hover-rise"
        mat-ripple
      >
        <i
          *ngIf="!changeStatusSelectiveLoading"
          class="mdi mdi-pencil mdi-20px tw-p-0 text-navyBlue"
        ></i>
        <span
          *ngIf="changeStatusSelectiveLoading"
          class="spinner-border spinner-border-sm text-navyBlue tw-mt-1"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>

    <!-- onEditDeliveryStatus all -->
    <button
      (click)="onEditDeliveryStatus('all')"
      *ngIf="userSession.organizationId() == 1"
      class="btn btn-light txt-lg button-shadow tw-mx-1 text-info btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.editStatusAllReceivers' | translate"
    >
      <i
        *ngIf="!changeStatusAllLoading"
        class="mdi mdi-circle-edit-outline mdi-20px tw-p-0 text-info"
      ></i>
      <span
        *ngIf="changeStatusAllLoading"
        class="spinner-border spinner-border-sm text-info tw-mt-1"
        role="status"
        aria-hidden="true"
      ></span>
    </button>

    <!-- onEditDeliveryStatus by excel file -->
    <div [matTooltip]="'common.editDeliveryStatusByExcelFile' | translate">
      <button
        (click)="onEditDeliveryStatus('byFile')"
        *ngIf="userSession.organizationId() == 1"
        [disabled]="(items$ | async)?.length == 0 || pageConfig.loading"
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-info btn-hover-rise"
        mat-ripple
      >
        <i
          *ngIf="!changeStatusByFileLoading"
          class="mdi mdi-upload mdi-20px tw-p-0 text-info"
        ></i>
        <span
          *ngIf="changeStatusByFileLoading"
          class="spinner-border spinner-border-sm text-info tw-mt-1"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>

    <!-- download -->
    <div [matTooltip]="'messages.allExcelReport' | translate">
      <button
        (click)="onDownloadReceiversGetApi()"
        [disabled]="(items$ | async)?.length == 0 || pageConfig.loading"
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-success btn-hover-rise"
        mat-ripple
        style="width: 51px"
      >
        <i
          *ngIf="!downloadLoading"
          class="mdi mdi-download mdi-20px tw-p-0 text-success"
        ></i>
        <span
          *ngIf="downloadLoading"
          class="spinner-border spinner-border-sm text-success tw-mt-1"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>

    <!-- refresh btn -->
    <a
      class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.refresh' | translate"
      (click)="onReset()"
    >
      <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
    </a>
  </div>

  <div class="tw-flex tw-justify-between tw-items-center tw-ml-5" scheduled-id>
    <span>(</span>
    <span
      class="tw-font-medium tw-text-base tw-text-gray-700 dark:tw-text-gray-300"
    >
      {{ "common.scheduledMessageId" | translate }} :
    </span>
    <span
      copyToClipboard
      class="text-navyBlue tw-py-1 rounded tw-text-xl tw-mr-2 tw-font-semibold"
      >{{ scheduledMessageId }}</span
    >
    <span>)</span>
  </div>

  <div
    class="tw-flex tw-justify-between tw-items-center tw-ml-5"
    recipient-count
  >
    (
    <span
      class="tw-font-medium tw-text-base tw-text-gray-700 dark:tw-text-gray-300"
      >{{ "common.recipientCount" | translate }} :
    </span>
    <span
      copyToClipboard
      class="text-navyBlue tw-py-1 rounded tw-text-xl tw-mr-2 tw-font-semibold"
      >{{ (modelWithPagination$ | async)?.totalCount | numberSeparator }}</span
    >
    )
  </div>

  <!-------------------------------------- Table Content ----------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr #row (click)="onActiveRow(row, i)">
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- checkbox -->
        <td>
          <div class="form-check tw-text-center">
            <input
              type="checkbox"
              class="form-check-input tw-mt-[1px]"
              (click)="onAddToMobileNumbers($event, item?.toNumber, row)"
              [attr.data-checkbox-id]="item.toNumber"
            />
          </div>
        </td>

        <!-- smsText -->
        <td
          class="msg-summary tw-text-center"
          [ngClass]="{
            ' tw-cursor-pointer': item?.smsText
          }"
        >
          <div
            class="tw-flex-center"
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
            textPopover
            [parentSelector]="'receivers-' + scheduledMessageId"
            [selectorType]="'id'"
            [fullText]="item?.smsText"
          >
            <p
              class="tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
            >
              {{ item?.smsText | checkValue }}
            </p>
          </div>
        </td>

        <!-- smsParts -->
        <td>
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.smsParts | numberSeparator"
          ></td-value>
        </td>

        <!-- toNumber -->
        <td *ngIf="!isSmartType">
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.toNumber"
          ></td-value>
        </td>

        <!-- SmsAggregator -->
        <td>
          <div
            class="tw-flex-center"
            [matTooltip]="
              item?.mobileOperator | enumToText : SmsAggregatorEnumValues
            "
            [matTooltipDisabled]="tooltipDisabled(item?.mobileOperator)"
            [mobileOperatorImg]="{
              mobileOperator: item?.mobileOperator,
              mobileOperatorEnumValue:
                item?.mobileOperator | enumToText : SmsAggregatorEnumValues
            }"
          ></div>
        </td>

        <!-- sendStatus -->

        <td>
          <span [sendStatusStyle]="item.sendStatus">
            {{ item.sendStatus | enumToText : SendStatusEnumValues }}
            <i
              *ngIf="item.sendStatus == SendStatus.Sent"
              class="mdi mdi-check-circle text-success"
            ></i>
          </span>
        </td>

        <!-- deliveryStatus -->
        <td>
          <span [deliveryStatusStyle]="item.deliveryStatus">
            {{ item.deliveryStatus | enumToText : DeliveryStatusEnumValues }}
            <i
              *ngIf="
                item.deliveryStatus == DeliveryStatus.Sent ||
                item.deliveryStatus == DeliveryStatus.SentAndReceivedbyPhone
              "
              class="mdi mdi-check-circle text-success"
            ></i>
          </span>
        </td>

        <!-- statusDateTime -->
        <td class="tw-py-3">
          <td-value
            copyToClipboard
            type="dateTimeWithSecond"
            [value]="item?.statusDateTime"
          ></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- help ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
